import { UrlUtils } from '@ddt-web/url';

/**
 * Debug surfaces (?cc- config overrides, the session config override and the ?debugWindow config editor) require an
 * internal login everywhere, and additionally a beta app in production. There is no host or build-mode exemption:
 * isDevMode() is true in deployed non-production builds, so exempting it would leave the surfaces open to external
 * users on test and internal hosts. When serving an app locally, set isInternalLogin: 'true' in the app's
 * globalAnalyticsParams (as apps/portfolio-analyser/src/index.html does) to use them.
 */
export function areDebugSurfacesAllowed(): boolean {
	const isInternalLogin = (window as any).globalAnalyticsParams?.isInternalLogin === 'true';
	if (!isInternalLogin) {
		return false;
	}

	return !UrlUtils.isProduction() || UrlUtils.isBetaApp();
}
